function initSwipe() {
  document.querySelectorAll('.mimari-proje-kart__slider').forEach(slider => {
    if (slider.dataset.swipeInit) return;
    slider.dataset.swipeInit = 'true';

    let startX = 0;

    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        const btn = diff > 0
          ? slider.querySelector('.mimari-proje-kart__slider-btn--next')
          : slider.querySelector('.mimari-proje-kart__slider-btn--prev');
        if (btn) btn.click();
      }
    }, { passive: true });
  });
}

document.addEventListener('DOMContentLoaded', initSwipe);

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initSwipe();
}
